import { cn } from "@/lib/utils";

export function Loader(props: { className?: string }) {
  return (
    <div className="flex gap-2">
      <div
        className={cn(
          "w-2 h-2 bg-primary rounded-full animate-dot-flashing",
          props.className
        )}
      />
      <div
        className={cn(
          "w-2 h-2 bg-primary rounded-full animate-dot-flashing opacity-30",
          props.className
        )}
        style={{ animationDelay: "0.3s" }}
      />
      <div
        className={cn(
          "w-2 h-2 bg-primary rounded-full animate-dot-flashing opacity-30",
          props.className
        )}
        style={{ animationDelay: "0.6s" }}
      />
    </div>
  );
}
